export const WINDRAW_STAGE_NAMES = ['Принятие заказа', 'Комплектация', 'Отгрузка'] as const

export type WindrawStageMarkState = 'missing' | 'unmarked' | 'partial' | 'marked'

export const getWindrawStageMarkState = (
  stage?: { totalCount: number; completedCount: number } | null,
): WindrawStageMarkState => {
  if (!stage || stage.totalCount <= 0) return 'missing'
  if (stage.completedCount <= 0) return 'unmarked'
  if (stage.completedCount < stage.totalCount) return 'partial'
  return 'marked'
}
